@file:OptIn(InternalResourceApi::class)

package showcaseapp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.RegionQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringArrayResource

private const val MD: String = "composeResources/showcaseapp.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_204_826_442)
internal val Res.array.ai_summary_preview_autumn_narrations: StringArrayResource by lazy {
      StringArrayResource("string-array:ai_summary_preview_autumn_narrations", "ai_summary_preview_autumn_narrations", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_summary_preview.commonMain.cvr", 10, 422),
        ResourceItem(setOf(), "${MD}values/ai_summary_preview.commonMain.cvr", 10, 562),
      ))
    }

@delegate:ResourceContentHash(-1_287_841_688)
internal val Res.array.ai_summary_preview_city_narrations: StringArrayResource by lazy {
      StringArrayResource("string-array:ai_summary_preview_city_narrations", "ai_summary_preview_city_narrations", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_summary_preview.commonMain.cvr", 433, 420),
        ResourceItem(setOf(), "${MD}values/ai_summary_preview.commonMain.cvr", 573, 472),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainArray0Resources(map: MutableMap<String, StringArrayResource>) {
  map.put("ai_summary_preview_autumn_narrations", Res.array.ai_summary_preview_autumn_narrations)
  map.put("ai_summary_preview_city_narrations", Res.array.ai_summary_preview_city_narrations)
}
